import React, { useState, FunctionComponent, FormEvent } from 'react';
import { Presentation } from './presentation';
import { CompanyForm, UserAuthForm } from '../../../types/companyRegisterForm';
import { getCsrfToken } from '../../../libs/csrfToken';
import { postNewPlan } from '../../../services/companies';

type Props = {
  handleFlash: (flash: boolean, type: string, message: string) => void;
  company: CompanyForm;
  userAuth: UserAuthForm;
  handleSectionChange: (newSection: 'profile' | 'plan') => void;
  handleChange: (section: 'company' | 'userAuth' | 'planPurchase', field: string, value: string | boolean| number) => void;
};

export const Component: FunctionComponent<Props> = ({
  handleFlash,
  company,
  userAuth,
  handleSectionChange,
  handleChange,
}) => {
  const[isLoading, setIsLoading] = useState(false);

  const validateCompanyProfileForm = (): boolean => {
    const requiredFields = [
      { value: company.name, field: '企業名・団体名' },
      { value: company.staffName, field: '貴社担当者名' },
      { value: company.phoneNumber, field: '貴社担当者の電話番号' },
      { value: company.oshiri, field: '弊社サービスを知ったきっかけ' },
      { value: userAuth.email, field: 'メールアドレス' },
      { value: userAuth.password, field: 'パスワード' },
      { value: userAuth.passwordConfirmation, field: 'パスワード（確認）' },
    ];
  const missingFields = requiredFields
    .filter(({ value }) => !value || value.trim() === '')
    .map(({ field }) => field);

    if (missingFields.length > 0) {
      handleFlash(true, 'danger', `${missingFields.join(' / ')} が未入力です。`);
      return false;
    }

    if (userAuth.password && userAuth.passwordConfirmation && userAuth.password !== userAuth.passwordConfirmation) {
      handleFlash(true, 'danger', '確認パスワードが一致しません');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    const isValid = validateCompanyProfileForm();
    if (!isValid) {
      setIsLoading(false);
      return;
    }

    const formData = new FormData();
    // user_auth_attributes
    formData.append('user[user_auth_attributes][email]', userAuth.email || '');
    formData.append('user[user_auth_attributes][password]', userAuth.password || '');
    formData.append('user[user_auth_attributes][password_confirmation]', userAuth.passwordConfirmation || '');
    // company_attributes
    formData.append('user[company_attributes][name]', company.name || '');
    formData.append('user[company_attributes][phone_number]', company.phoneNumber || '');
    formData.append('user[company_attributes][staff_name]', company.staffName || '');
    formData.append('user[company_attributes][url]', company.url || '');
    formData.append('user[company_attributes][oshiri]', company.oshiri || '');
    formData.append('user[company_attributes][riyohoho]', company.riyohoho || '');

    try {
      const response = await postNewPlan(formData, getCsrfToken());
      if (response.errorMessages) {
        setIsLoading(false);
        handleFlash(true, 'danger', response.errorMessages);
        return;
      }
      handleSectionChange('plan');
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Presentation
      company={company}
      userAuth={userAuth}
      isLoading={isLoading}
      handleChange={handleChange}
      onSubmit={handleSubmit}
    />
  );
};
